module.exports = __webpack_public_path__ + "img/20210109_105744.902d1bee.jpg";